import React from 'react'
import Navigation from './Navbar/Navigation'
import Footer from './Footer/Footer'
const Layout = ({children}) => {
  return (
    <div>
      <Navigation/>
      {children}
      <Footer/>
    </div>
  )
}

export default Layout
